/**
 * Appversion. Systemversionen hentes fra GET /api/version efter login
 * (se useSystemVersion); vaerdien herunder er build-versionen og bruges som
 * fallback, indtil - eller hvis - kaldet svarer.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.0.0';
